import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { environment } from "../environments/environment";

const ENV_LABEL: Record<string, string> = {
  dev: "DEV",
  intg: "BETA",
};

@Component({
  selector: "sdx-root",
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <router-outlet />
    @if (envLabel) {
      <span class="env-badge env-badge--{{ envLabel.toLowerCase() }}">{{ envLabel }}</span>
    }
  `,
  styles: [`
    .env-badge {
      position: fixed;
      top: 20px;
      left: -32px;
      z-index: 9999;
      width: 130px;
      padding: 5px 0;
      text-align: center;
      font-size: 0.65rem;
      font-weight: 800;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #fff;
      transform: rotate(-45deg);
      pointer-events: none;
      user-select: none;
      box-shadow: 0 2px 6px rgba(0,0,0,0.25);
    }
    .env-badge--dev  { background: #ea580c; }
    .env-badge--beta { background: #c2410c; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  protected readonly envLabel = ENV_LABEL[environment.version.split("-")[1] ?? ""] ?? null;
}
